import { useState } from "react";
import PhoneInput from "react-phone-input-2";
import { Button, Dropdown, Form, Icon, Image, Input, Modal, Select } from "semantic-ui-react";
import { getBookingByConfirmationNumber } from "services/hotels";
import { createRoomReady, updateRoomReady } from "services/roomReadys";

const noError = {
  email: ""
}
export default function WeChatQrCodePopup(props: any): JSX.Element {
  const {
    qrCode,
    popup,
    setPopup,
  } = props

  return (
    <Modal
      size="tiny"
      onClose={() => setPopup({ ...popup, wechatQrcode: false })}
      open={popup.wechatQrcode}
    >
      <Modal.Header className="text-left">
        <div>
          <span>WeChat QRcode</span>
        </div>
      </Modal.Header>
      <Modal.Content className="text-left">
        <div>
          <Image
            src={qrCode.qrcode}
            fluid
          />
        </div>
      </Modal.Content>
      <Modal.Actions >
        <Button color='black' onClick={() => {
          setPopup({
            ...popup,
            wechatQrcode: false
          })
        }}>
          Close
        </Button>
      </Modal.Actions>
    </Modal>
  )
}
